import React, { useEffect } from "react";

const TermsModal = ({ isOpen, onClose }) => {
  // Always run hooks; guard inside.
  useEffect(() => {
    if (!isOpen) return;
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const onKey = (e) => e.key === "Escape" && onClose?.();
    window.addEventListener("keydown", onKey);

    return () => {
      document.body.style.overflow = prevOverflow;
      window.removeEventListener("keydown", onKey);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const stop = (e) => e.stopPropagation();

  const termsData = {
    date: "2025-02-23",
    websiteName: "LottoGPT",
    contactInfo: "contact@lotto-gpt.io",
  };

  return (
    <div
      className="fixed inset-0 z-[1000] bg-black/50 backdrop-blur-sm flex items-center justify-center p-4"
      role="dialog"
      aria-modal="true"
      onClick={onClose}
    >
      <div
        className="relative w-full max-w-3xl bg-white rounded-2xl shadow-xl"
        onClick={stop}
      >
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b">
          <h1 className="text-xl sm:text-2xl font-semibold text-gray-900">
            Terms of Use
          </h1>
          <button
            onClick={onClose}
            className="inline-flex items-center justify-center rounded-lg border border-gray-300 px-3 py-1.5 text-sm text-gray-600 hover:bg-gray-100"
          >
            Close
          </button>
        </div>

        {/* Scrollable content */}
        <div className="px-6 py-5 max-h-[70vh] overflow-y-auto">
          <p className="text-sm text-gray-500 mb-4">
            Last Updated: <span className="font-medium text-gray-800">{termsData.date}</span>
          </p>

          <section className="mb-6">
            <h2 className="text-gray-900 font-semibold text-base border-b-2 border-emerald-400 pb-1">
              1. No Guarantee of Results
            </h2>
            <p className="text-gray-700 leading-relaxed mt-3">
              {termsData.websiteName} provides lottery number predictions based on various
              methodologies. However, we do not guarantee accuracy, effectiveness, or
              profitability. Lottery outcomes are random, and no method can predict results
              with certainty.
            </p>
          </section>

          <section className="mb-6">
            <h2 className="text-gray-900 font-semibold text-base border-b-2 border-emerald-400 pb-1">
              2. Personal Responsibility & Risk
            </h2>
            <p className="text-gray-700 leading-relaxed mt-3">
              Your use of the Website and reliance on our predictions is at your own risk.
              Gambling involves financial risk, and we are not liable for any losses.
            </p>
          </section>

          <section className="mb-6">
            <h2 className="text-gray-900 font-semibold text-base border-b-2 border-emerald-400 pb-1">
              3. Age Requirement
            </h2>
            <p className="text-gray-700 leading-relaxed mt-3">
              You must be at least 18 years old (or the legal gambling age in your jurisdiction)
              to use our Website.
            </p>
          </section>

          <section className="mb-6">
            <h2 className="text-gray-900 font-semibold text-base border-b-2 border-emerald-400 pb-1">
              4. No Financial or Legal Advice
            </h2>
            <p className="text-gray-700 leading-relaxed mt-3">
              Our Website provides information for entertainment purposes only and does not
              constitute financial or legal advice.
            </p>
          </section>

          <section className="mb-6">
            <h2 className="text-gray-900 font-semibold text-base border-b-2 border-emerald-400 pb-1">
              5. User Conduct
            </h2>
            <p className="text-gray-700 leading-relaxed mt-3">
              You agree to use the Website lawfully. We reserve the right to suspend or
              terminate access for violations.
            </p>
          </section>

          <section className="mb-6">
            <h2 className="text-gray-900 font-semibold text-base border-b-2 border-emerald-400 pb-1">
              6. Intellectual Property
            </h2>
            <p className="text-gray-700 leading-relaxed mt-3">
              All content on the Website is owned by or licensed to {termsData.websiteName}.
              You may not use our content without permission.
            </p>
          </section>

          <section className="mb-6">
            <h2 className="text-gray-900 font-semibold text-base border-b-2 border-emerald-400 pb-1">
              7. Limitation of Liability
            </h2>
            <p className="text-gray-700 leading-relaxed mt-3">
              We disclaim liability for damages arising from your use of the Website.
            </p>
          </section>

          <section className="mb-6">
            <h2 className="text-gray-900 font-semibold text-base border-b-2 border-emerald-400 pb-1">
              8. Changes to These Terms
            </h2>
            <p className="text-gray-700 leading-relaxed mt-3">
              We may update these Terms at any time. Continued use of the Website after
              changes are posted constitutes acceptance.
            </p>
          </section>

          <section className="mb-2">
            <h2 className="text-gray-900 font-semibold text-base border-b-2 border-emerald-400 pb-1">
              9. Contact Us
            </h2>
            <p className="text-gray-700 leading-relaxed mt-3">
              If you have any questions, contact us at {termsData.contactInfo}.
            </p>
          </section>
        </div>

        {/* Footer */}
        <div className="px-6 pb-6">
          <button
            onClick={onClose}
            className="w-full sm:w-auto bg-emerald-500 hover:bg-emerald-600 text-white font-semibold px-5 py-2.5 rounded-xl"
          >
            I Understand
          </button>
        </div>
      </div>
    </div>
  );
};

export default TermsModal;